<div class="flex min-h-screen items-center justify-center px-4 py-8">
  <div class="flex w-full max-w-md flex-col gap-6">
    <app-logo [widthInPx]="120" />

    <div hlmCard>
      <div hlmCardHeader>
        <h1 hlmCardTitle>E-Mail bestätigen</h1>
        <p hlmCardDescription>Bestätige deine E-Mail-Adresse, um deinen Account zu aktivieren.</p>
      </div>

      <div hlmCardContent class="space-y-4">
        @if (loading) {
          <div class="flex flex-col items-center gap-3 py-6 text-center">
            <hlm-spinner class="text-[length:--spacing(8)]" />
            <p hlmMuted class="text-sm">Wir bestätigen deine E-Mail-Adresse…</p>
          </div>
        } @else if (verified) {
          <div hlmAlert>
            <ng-icon name="lucideCircleCheck" />
            <p hlmAlertTitle>E-Mail erfolgreich bestätigt</p>
            <p hlmAlertDescription>Dein Account wurde aktiviert.</p>
          </div>

          <button hlmBtn class="w-full" (click)="goToLogin()">Jetzt anmelden</button>
        } @else {
          <!-- Missing token and failed verification lead to the same two options -->
          <div hlmAlert variant="destructive">
            <ng-icon name="lucideTriangleAlert" />
            <p hlmAlertTitle>
              {{ token ? 'Bestätigung fehlgeschlagen' : 'Kein Bestätigungslink gefunden' }}
            </p>
            <p hlmAlertDescription>
              {{
                token
                  ? error
                  : 'Der Link scheint unvollständig zu sein. Prüfe deine E-Mail oder fordere eine neue Bestätigung an.'
              }}
            </p>
          </div>

          <div class="flex flex-col gap-2">
            <button hlmBtn variant="outline" [disabled]="resending" (click)="resendVerification()">
              @if (resending) {
                <hlm-spinner />
                Wird gesendet…
              } @else {
                Neue Bestätigungs-E-Mail senden
              }
            </button>
            <button hlmBtn (click)="goToLogin()">Zur Anmeldung</button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
